import React from "react";
import PropTypes from "prop-types";

import ReactTooltip from "react-tooltip";
import MsxIcons from "../MsxIcons/MsxIcons";

const DeleteCross = ({ tableRowRemove, index, showToolTip, toolTipMessage, disable }) => (
  <>
    <button type="button" className="flex flex-col h-5 justify-center" onClick={() => tableRowRemove(index)}>
      <div data-tip className="cursor-pointer flex" tabIndex={-1}>
        <MsxIcons
          size="small"
          className="text-red-600 trasform scale-75"
          name="action_delete_cross"
          disabled={disable}
        />
        {showToolTip && (
          <ReactTooltip
            place="right"
            effect="solid"
            backgroundColor="#FFFFFF"
            textColor="rgb(31 41 55)"
            className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
          >
            <div>{toolTipMessage}</div>
          </ReactTooltip>
        )}
      </div>
    </button>
  </>
);

DeleteCross.propTypes = {
  tableRowRemove: PropTypes.func,
  index: PropTypes.number,
  showToolTip: PropTypes.bool,
  toolTipMessage: PropTypes.string,
  disable: PropTypes.bool
};

DeleteCross.defaultProps = {
  tableRowRemove: null,
  index: null,
  showToolTip: false,
  toolTipMessage: "",
  disable: false
};
export default DeleteCross;
